// consts/enums
import { NAME } from '../common/taxesAndFeesConsts';
import type { SimpleTableHeadColumn } from './TableHead';
import { FINANCE_MIN_WIDTH, FINANCE_NAME_MIN_WIDTH, LEASE_MIN_WIDTH, LEASE_NAME_MIN_WIDTH } from './FeesCard.style';

export const CODE = 'Code';
export const AMOUNT = 'Amount';
export const UPFRONT = 'Upfront';

export const FINANCE_FEETABLECOLUMNS: SimpleTableHeadColumn[] = [
    { heading: CODE, options: { minWidth: FINANCE_MIN_WIDTH } },
    { heading: NAME, options: { minWidth: FINANCE_NAME_MIN_WIDTH, textAlign: 'center', justifyContent: 'center' } },
    { heading: AMOUNT, options: { minWidth: FINANCE_MIN_WIDTH, textAlign: 'right', justifyContent: 'flex-end' } }
];
export const LEASE_FEETABLECOLUMNS: SimpleTableHeadColumn[] = [
    { heading: CODE, options: { minWidth: LEASE_MIN_WIDTH } },
    { heading: NAME, options: { minWidth: LEASE_NAME_MIN_WIDTH, textAlign: 'center', justifyContent: 'center' } },
    { heading: UPFRONT, options: { minWidth: LEASE_MIN_WIDTH, textAlign: 'center', justifyContent: 'center' } },
    { heading: AMOUNT, options: { minWidth: LEASE_MIN_WIDTH, textAlign: 'right', justifyContent: 'flex-end' } }
];

export const ELIMINATED_FEE_AMOUNT = 0;
export const DELETED_BY_ACTION_FEE_AMOUNT = '0';
export const ADDED_FEE_CODE = 0;
export const ADDED_FEE_AMOUNT = '1';

// Debounce window used to coalesce rapid fee changes (deletions/restores and upfront-checkbox
// toggles) into a single payment (PO) call, preventing a flood of overlapping recalculations.
export const SOFT_SAVE_DEBOUNCE_MS = 500;

export const CAP_INDICATOR = 'capIndicator';

export const GOV_DEALER_TITLE = 'Government and Dealer Fees';
export const LENDER_DEALER_GOV_TITLE = 'Lender, Government and Dealer Fees';

export const REGISTRATION_TYPE = [
    {
        disabled: false,
        label: 'New',
        value: 'New'
    },
    {
        disabled: false,
        label: 'Transfer',
        value: 'Transfer'
    },
    {
        disabled: false,
        label: 'Title Only',
        value: 'TitleOnly'
    },
    {
        disabled: false,
        label: 'Custom',
        value: 'Manual'
    }
];

export const STATE_REGISTRATION_TYPE_ALLOWLIST: Record<string, string[]> = {
    AL: ['New', 'Transfer', 'Manual'],
    AZ: ['New', 'Transfer', 'Manual'],
    CA: ['New', 'Manual'],
    CO: ['New', 'TitleOnly', 'Manual'],
    CT: ['New', 'Transfer', 'Manual'],
    HI: ['New', 'Transfer', 'Manual'],
    IA: ['New', 'Transfer', 'Manual'],
    LA: ['New', 'Manual'],
    MN: ['New', 'Manual'],
    MS: ['New', 'Transfer', 'Manual'],
    MT: ['New', 'Transfer', 'Manual'],
    OK: ['New', 'Transfer', 'Manual'],
    TN: ['New', 'Transfer', 'Manual'],
    TX: ['New', 'Transfer', 'Manual']
};
